var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-modal",
    {
      staticClass: "modal-content",
      attrs: {
        title: _vm.title,
        width: 870,
        visible: _vm.visible,
        "ok-text": "保存",
      },
      on: { ok: _vm.handleOk, cancel: _vm.handleCancel },
    },
    [
      [
        _c(
          "a-form-model",
          {
            ref: "ruleForm",
            attrs: {
              labelCol: { span: 3 },
              wrapperCol: { span: 20 },
              model: _vm.form,
              rules: _vm.rules,
            },
          },
          [
            _c(
              "a-form-model-item",
              { attrs: { label: "标题", prop: "title" } },
              [
                _c("a-input", {
                  attrs: { placeholder: "请输入标题" },
                  model: {
                    value: _vm.form.title,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "title", $$v)
                    },
                    expression: "form.title",
                  },
                }),
              ],
              1
            ),
            _c(
              "a-form-model-item",
              { attrs: { label: "选择分类", prop: "classify" } },
              [
                _c("j-dict-select-tag", {
                  attrs: {
                    placeholder: "请选择分类",
                    dictCode: _vm.cateDictCode,
                    allowClear: "",
                  },
                  model: {
                    value: _vm.form.classify,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "classify", $$v)
                    },
                    expression: "form.classify",
                  },
                }),
              ],
              1
            ),
            _c(
              "a-form-model-item",
              { attrs: { label: "上传封面", prop: "file" } },
              [
                _c(
                  "div",
                  { staticClass: "flex-align-center" },
                  [
                    _c("JImageUpload", {
                      ref: "coverRef",
                      attrs: { bizPath: "resourceCource" },
                    }),
                    _c("span", { staticStyle: { color: "#cdcdcd" } }, [
                      _vm._v("*建议封面尺寸444 * 252，大小不超过500kb"),
                    ]),
                  ],
                  1
                ),
              ]
            ),
            _c(
              "a-form-model-item",
              { attrs: { label: "详细介绍", prop: "content" } },
              [
                _c("WangEditor", {
                  staticStyle: {
                    margin: "2px",
                    border: "1px solid #d9d9d9",
                    "border-radius": "4px",
                    overflow: "hidden",
                  },
                  attrs: { editorStyle: { minHeight: "200px" } },
                  model: {
                    value: _vm.form.content,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "content", $$v)
                    },
                    expression: "form.content",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }